import { motion, useScroll, useTransform } from "framer-motion";
import { Radio, Clock3, Signal, Flame } from "lucide-react";

const lines = [
  { text: "EL MAPA", style: "text-rosewhite" },
  { text: "INVISIBLE", style: "text-stroke-magenta" },
  { text: "DE TU MARCA", style: "text-rosewhite" },
];

const meta = [
  { icon: Radio, label: "3 sesiones en vivo" },
  { icon: Clock3, label: "6 horas totales" },
  { icon: Signal, label: "7 señales CEREBRO" },
  { icon: Flame, label: "Sold out" },
];

const Hero = () => {
  const { scrollYProgress } = useScroll();
  const bgY = useTransform(scrollYProgress, [0, 0.25], [0, 180]);
  const fade = useTransform(scrollYProgress, [0, 0.2], [1, 0]);

  return (
    <section id="top" className="relative flex min-h-screen flex-col overflow-hidden" data-testid="hero-section">
      <motion.div className="absolute inset-0" style={{ y: bgY }}>
        <img
          src="https://images.unsplash.com/photo-1773983361731-05dc42b99fde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGxpZ2h0JTIwdHJhaWxzJTIwbWFnZW50YSUyMGN5YW58ZW58MHx8fHwxNzg1OTY0MTk5fDA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="h-[120%] w-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-plum/70 via-plum/55 to-plum" />
        <div className="absolute inset-0 scanlines" />
      </motion.div>

      <motion.div style={{ opacity: fade }} className="relative z-10 mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-6 pt-32 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mb-8 flex items-center gap-3 text-xs font-medium uppercase tracking-[0.35em] text-neoncyan"
          data-testid="hero-kicker"
        >
          <span className="h-px w-10 bg-neoncyan/70" />
          Neuromarketing aplicado a marcas reales · Online en vivo
        </motion.p>

        <h1 className="font-display font-black uppercase leading-[0.92] tracking-tighter" data-testid="hero-title">
          {lines.map((line, i) => (
            <span key={line.text} className="block overflow-hidden pb-1">
              <motion.span
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, delay: 0.55 + i * 0.16, ease: [0.22, 1, 0.36, 1] }}
                className={`block text-[13.5vw] md:text-[9vw] ${line.style}`}
              >
                {line.text}
              </motion.span>
            </span>
          ))}
        </h1>

        <div className="mt-10 flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 1.25 }}
            className="max-w-md text-base text-lilac md:text-lg"
            data-testid="hero-subtitle"
          >
            Un curso práctico e interactivo para entender qué señales está enviando tu marca
            al cerebro del consumidor, y cómo esas señales deciden la compra antes de que
            nadie pueda explicarlas.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 1.4 }}
            className="flex flex-col gap-6"
          >
            <div className="flex flex-wrap gap-3">
              {meta.map((m) => (
                <span
                  key={m.label}
                  className="glass flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-[0.15em] text-lilac"
                >
                  <m.icon className="h-3.5 w-3.5 text-magenta" />
                  {m.label}
                </span>
              ))}
            </div>
            <span
              data-testid="hero-cta-reservar"
              className="inline-flex w-fit cursor-not-allowed items-center gap-3 border border-orange-500/60 px-8 py-4 font-display text-sm font-extrabold uppercase tracking-[0.2em] text-orange-400"
            >
              Sold out · cupos agotados
            </span>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.8 }}
        className="relative z-10 mx-auto flex w-full max-w-7xl items-center justify-between px-6 pb-10 pt-16 md:px-12"
      >
        <p className="font-editorial text-lg italic text-lilac/80 md:text-xl">
          25 · 27 · 29 de agosto · GMT-3
        </p>
        <p className="hidden text-xs uppercase tracking-[0.3em] text-lilac/50 md:block">
          Scroll para descubrir el mapa
        </p>
      </motion.div>
    </section>
  );
};

export default Hero;
